// extracted by css-extract-rspack-plugin
export default {"button":"SV8aT5drIcYVLD35","small":"eKD4kyOUK8AkrkWr","body":"hgzN_7j7upAiWkUx"};